import styled from 'styled-components';
import { Card } from 'antd';

export const StyledHomeContainer = styled.div`
  padding: 24px;
  max-width: 1200px;
  margin: 0 auto;
`;

export const StyledCard = styled(Card)<{ $clickable?: boolean }>`
  margin-bottom: 24px;
  border-radius: 16px;
  box-shadow: 
    0 1px 3px rgba(0, 0, 0, 0.06),
    0 2px 6px rgba(0, 0, 0, 0.04);
  border: 1px solid #e8e8e8;
  cursor: ${props => props.$clickable ? 'pointer' : 'default'};
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    ${props => props.$clickable ? `
      transform: translateY(-2px);
      box-shadow: 
        0 4px 12px rgba(0, 0, 0, 0.08),
        0 8px 24px rgba(0, 0, 0, 0.04);
      border-color: #1890ff;
    ` : `
      border-color: #d9d9d9;
    `}
  }
`;

